export class Task {
    public tasktype: TaskType;
    protected description: string;
    protected pupilSolution: string = "";
    protected skeleton: string[] = [""];
    private editorContent: string = null;
    private inputLine: string = "";
    private chosenButNotHandedInOption: string = null;
    public handedIn: boolean = false;
    public modified: boolean = false;
    private image: ArrayBuffer | string = null;
    private imageFile: File = null;
    private hasImage: boolean = false;

    private history: any[] = [];
    private canvasState: any[] = null;

    //global identifier
    protected id: string;
    //local identifier
    protected label: string;


    constructor(id_?: string, description_: string = "", solution_: string = "", type_: TaskType = TaskType.DRAWX, skeleton_: string[] = [], label_: string = "") {
        this.id = id_;
        if (this.id == null) {
            this.id = this.generateId();
        }
        this.label = label_;
        this.description = description_;
        this.pupilSolution = solution_;
        this.tasktype = type_;
        this.skeleton = skeleton_;
    }

    public forJSON() {
        return { tasktype: this.tasktype, description: this.description, solution: this.pupilSolution, skeleton: this.skeleton, label: this.label, id: this.id }
    }

    public getId(): string {
        return this.id;
    }

    public setHistory(history: Object[]): void {
        this.history = history;
    }

    public getHistory(): Object[] {
        return this.history;
    }

    public getInputLine(): string {
        return this.inputLine;
    }

    public setInputLine(i: string): void {
        this.inputLine = i;
    }

    public setCanvasState(state: any[]) {
        this.canvasState = state;
    }

    public getCanvasState(): any[] {
        return this.canvasState;
    }

    public setSkeleton(skel: string[]) {
        this.skeleton = skel;
    }

    public getSkeleton(): string[] {
        return this.skeleton;
    }

    public getEditorContent(): string {
        return this.editorContent;
    }

    public setEditorContent(val: string): void {
        this.editorContent = val;
    }

    protected generateId(): string {
        //TODO: implement
        return "foo";
    }

    public setPupilSolution(sol: string) {
        this.pupilSolution = sol;
    }

    public getPupilSolution(): string {
        return this.pupilSolution;
    }

    public getChosenButNotHandedInOption(): string {
        return this.chosenButNotHandedInOption;
    }

    public setChosenButNotHandedInOption(val: string): void {
        this.chosenButNotHandedInOption = val;
    }

    public getLabel(): string {
        return this.label;
    }

    public getDescription(): string {
        return this.description;
    }

    public getSolution(): string {
        return this.pupilSolution;
    }

    public setImageFromBlob(file: any) {
        const reader: FileReader = new FileReader();
        reader.addEventListener('load', (event: any) => {
            var res: string = <string>reader.result;
            var l = res.length;
            var l2 = "image/jpeg".length;
            var index = res.indexOf("base64,")
            if (res[5] == ";" || l2 < l && res.substring(5, 5 + l2) != "image/jpeg") {
                res = res.substring(0, 5) + "image/jpeg;" + res.substring(index, l)
            }
            this.image = res;
            this.hasImage = true;
        });
        reader.readAsDataURL(file);
        this.imageFile = file;
    }

    public setImage(file: File) {
        const reader: FileReader = new FileReader();
        reader.addEventListener('load', (event: any) => {
            var res: string = <string>reader.result;
            var l = res.length;
            var l2 = "image/jpeg".length;
            var index = res.indexOf("base64,")
            if (res[5] == ";" || l2 < l && res.substring(5, 5 + l2) != "image/jpeg") {
                res = res.substring(0, 5) + "image/jpeg;" + res.substring(index, l)
            }
            this.image = res;
            this.hasImage = true;
        });
        reader.readAsDataURL(file);
        this.imageFile = file;
    }

    public retrieveSolutionJSON(): any {
        var obj = {
            id: this.id,
            solution: this.pupilSolution,
            editorContent: this.editorContent,
            history: this.history
        }
        return obj;
    }


    public retrieveBackupJSON(): any {
        var obj = {
            id: this.id,
            editorContent: this.editorContent,
            history: this.history,
            chosenButNotHandedInOption: this.chosenButNotHandedInOption,
            handedIn: this.handedIn,
            modified: this.modified,
            inputLine: this.inputLine
        }
        return obj;
    }



    /////////////// These methods are used in HTML, because cannot access static members in html //////////
    public checkDrawX(): boolean {
        return this.tasktype == TaskType.DRAWX;
    }

    public checkMC(): boolean {
        return this.tasktype == TaskType.MC;
    }

    public checkExtendTemplate(): boolean {
        return this.tasktype == TaskType.EXTEND_TEMPLATE
    }

    public skeletonNeeded(): boolean {
        return this.tasktype != TaskType.DRAWX;
    }


}

export enum TaskType {
    //It is IMPORTANT that first number is 1 and not 0!! (For select html)
    DRAWX = 1,
    MC = 2,
    EXTEND_TEMPLATE = 3
}


export class MultipleChoiceOption {
    public text: string;
    public image: HTMLImageElement;
}

export class RestoreCanvasEvent {
    public commands: string[];
    public editorContent: string;
}



// WEBPACK FOOTER //
// ./src/app/lib/Task.ts